import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pos/32.png'
import _imports_1 from '@/assets/pos/green32.png'
import _imports_2 from '@/assets/pos/red32.png'


const _withScopeId = n => (_pushScopeId("data-v-1106463e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leftBox" }
const _hoisted_2 = { class: "itemBox flex between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px"} }, null, -1))
const _hoisted_4 = { class: "itemBox flex between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px"} }, null, -1))
const _hoisted_6 = { class: "itemBox flex between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px"} }, null, -1))
const _hoisted_8 = { class: "searchBox" }
const _hoisted_9 = {
  key: 0,
  style: {"padding":"0 0 0 20px","margin-top":"10px","width":"calc(100% + 20px)"}
}
const _hoisted_10 = { style: {"height":"50px","line-height":"50px","font-size":"12px","color":"#000000","font-weight":"600"} }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex between" }
const _hoisted_13 = { style: {
                      color: '#666',
                      'font-weight': '600',
                      'font-size': '16px',
                    } }
const _hoisted_14 = {
  key: 0,
  class: "stateTips"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "终端标记结果正在审核中,不允许修改", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString("已标记"), -1))
const _hoisted_17 = { class: "batch" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { style: {"cursor":"pointer","font-size":"12px"} }
const _hoisted_22 = { style: { color: '#666' } }
const _hoisted_23 = { style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"14px","padding-right":"40px"} }
const _hoisted_24 = {
  style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"4px"},
  class: "flex"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labelBox" }, "地址", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_27 = {
  style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"4px"},
  class: "flex"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labelBox" }, "渠道", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_30 = {
  style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"4px"},
  class: "flex"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labelBox" }, "坐标", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"5px"} }, ";", -1))
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "positionTips" }
const _hoisted_36 = {
  key: 1,
  style: {"height":"65px","line-height":"65px","text-align":"right","background":"#ffffff","width":"calc(100% + 40px)","margin-left":"-20px","box-shadow":"0px -1px 2px rgba(204, 204, 204, 1)"}
}
const _hoisted_37 = {
  key: 0,
  style: {"width":"300px","color":"#858585","text-align":"center"}
}
const _hoisted_38 = {
  key: 1,
  style: {"width":"440px","color":"#858585"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900"} }, "终端标记规则："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"0"} }, " 单次检索结果标记，只允许标记一个保留终端、且必须存在重复终端（重复终端个数大于等于1），才可以点击完成标记按钮，实现一次完整的终端标记流程。 ")
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "mapBox" }
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"mapTips\" data-v-1106463e><div style=\"margin-right:26px;\" data-v-1106463e><img src=\"" + _imports_0 + "\" data-v-1106463e> 未标记终端 </div><div data-v-1106463e><img src=\"" + _imports_1 + "\" data-v-1106463e> 保留终端 </div><div style=\"margin:0 26px;\" data-v-1106463e><img src=\"" + _imports_2 + "\" data-v-1106463e> 重复终端 </div></div>", 1)
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f00"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 请再次确认是否标记以下终端 ")
], -1))
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "terminalNameBox longBox" }
const _hoisted_46 = ["title"]
const _hoisted_47 = ["title"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cascader = _resolveComponent("Cascader")!
  const _component_Form_item = _resolveComponent("Form-item")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_PositionIcon = _resolveComponent("PositionIcon")!
  const _component_Tab_pane = _resolveComponent("Tab-pane")!
  const _component_AuditLog = _resolveComponent("AuditLog")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Map = _resolveComponent("Map")!
  const _component_DecorateModalTitle = _resolveComponent("DecorateModalTitle")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "outCell flex masterMap_Map",
    style: _normalizeStyle({ height: _ctx.maxHeight })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Tabs, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeKey) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Tab_pane, {
            key: "1",
            tab: "关键词检索",
            style: {}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Form, {
                model: _ctx.formState,
                ref: "formRef",
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_Form_item, {
                      label: "省/市/区",
                      name: "province",
                      colon: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Cascader, {
                          value: _ctx.formState.province,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.province) = $event)),
                          options: _ctx.cascaderOptions,
                          "show-search": true,
                          placeholder: "请选择",
                          onFocus: _ctx.focusCascader,
                          onChange: _ctx.changeCascader,
                          "change-on-select": ""
                        }, null, 8, ["value", "options", "onFocus", "onChange"])
                      ]),
                      _: 1
                    }),
                    _hoisted_3,
                    _createVNode(_component_Form_item, {
                      label: "街道",
                      name: "town",
                      colon: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          value: _ctx.formState.town,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.town) = $event)),
                          options: _ctx.townOptions,
                          placeholder: "请选择",
                          onFocus: _ctx.focusTown,
                          allowClear: "",
                          "show-search": ""
                        }, null, 8, ["value", "options", "onFocus"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_Form_item, {
                      label: "终端名称 / 编码",
                      name: "fmesName",
                      colon: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          value: _ctx.formState.fmesName,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.fmesName) = $event)),
                          options: _ctx.fmesNameOptions,
                          placeholder: "请选择",
                          onFocus: _ctx.focusFmesName,
                          allowClear: "",
                          "show-search": "",
                          onSearch: _ctx.searchFmesName,
                          onChange: _ctx.getKeywords,
                          filterOption: _ctx.filterOption
                        }, null, 8, ["value", "options", "onFocus", "onSearch", "onChange", "filterOption"])
                      ]),
                      _: 1
                    }),
                    _hoisted_5,
                    _createVNode(_component_Form_item, {
                      label: "关键词",
                      name: "keyWords",
                      colon: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Input, {
                          placeholder: "请输入",
                          value: _ctx.formState.keyWords,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.keyWords) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Form_item, {
                      label: "距离范围",
                      name: "scape",
                      colon: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          value: _ctx.formState.scape,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.scape) = $event)),
                          options: _ctx.scapeOptions,
                          placeholder: "请选择"
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _hoisted_7,
                    _createVNode(_component_Form_item, {
                      label: " ",
                      colon: false
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_Button, {
                            type: "primary",
                            onClick: _ctx.search
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SearchOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                              _createTextVNode(" 搜索 ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            style: {"margin-left":"10px","border-color":"#008bcf","color":"#008bcf"},
                            onClick: _ctx.reset
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SyncOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                              _createTextVNode("重置")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              (this.showData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, " 数据查询结果(共" + _toDisplayString(_ctx.total) + "条) ", 1),
                    _createElementVNode("div", {
                      style: _normalizeStyle({
                height: _ctx.resultHeight,
                'overflow-y': 'auto',
                'padding-right': '20px',
                'min-height': '200px',
              })
                    }, [
                      (this.dataList.length === 0)
                        ? (_openBlock(), _createBlock(_component_Empty, {
                            key: 0,
                            description: "暂无数据",
                            style: {"margin-top":"60px"}
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: {"border":"1px dashed rgba(224, 224, 224, 1)","border-radius":"4px","padding":"22px 0 12px 60px","margin-bottom":"10px","position":"relative"},
                          key: item.fmesCode,
                          onClick: ($event: any) => (_ctx.clickForBig(item))
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(item.fmesName), 1),
                            (_ctx.$store.state.authc.authc
          .ButtonBasic_pg_basiData_terminalMap_sign)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (item.auditStatus === '待审核')
                                    ? (_openBlock(), _createBlock(_component_Popover, {
                                        key: 0,
                                        placement: "top",
                                        class: "masterMap"
                                      }, {
                                        content: _withCtx(() => [
                                          _hoisted_15
                                        ]),
                                        default: _withCtx(() => [
                                          _hoisted_16
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_Popover, {
                                        key: 1,
                                        placement: "rightTop",
                                        class: "masterMap"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(item.signType == 1 ? 'active' : ''),
                                              onClick: ($event: any) => {
                              item.signType = 1;
                              this.isEdit++;
                            }
                                            }, " 保留终端 ", 10, _hoisted_18),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(item.signType == 2 ? 'active' : ''),
                                              onClick: ($event: any) => {
                              item.signType = 2;
                              this.isEdit++;
                            }
                                            }, " 重复终端 ", 10, _hoisted_19),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.delSignType(item))
                                            }, "取消标记", 8, _hoisted_20)
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.checkSignType(item.signType)), 1),
                                            _createVNode(_component_RightOutlined, { style: {"color":"#8c8c8c","margin-left":"5px"} })
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item.storeShortId), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _hoisted_26,
                            _createElementVNode("span", null, _toDisplayString(item.address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _hoisted_29,
                            _createElementVNode("span", null, _toDisplayString(item.kindCategory) + ">" + _toDisplayString(item.kind) + ">" + _toDisplayString(item.channel), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _hoisted_32,
                            _createElementVNode("span", null, [
                              _createTextVNode(_toDisplayString(item.baiduLat) + " ", 1),
                              _hoisted_33,
                              _createTextVNode(" " + _toDisplayString(item.baiduLon), 1)
                            ]),
                            (
                      item.auditStatus !== '待审核' &&
                      _ctx.$store.state.authc.authc
                        .ButtonBasic_pg_basiData_terminalDetails_edit&&_ctx.$store.state.authc.authc
          .ButtonBasic_pg_basiData_terminalMap_sign
                    )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: {"cursor":"pointer","color":"#008bcf","margin-left":"9px"},
                                  onClick: ($event: any) => (_ctx.coordinate(item))
                                }, " [修改] ", 8, _hoisted_34))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_PositionIcon, {
                              index: item.beforeIndex + 1,
                              bgcolor: this.checkColor(item.signType)
                            }, null, 8, ["index", "bgcolor"])
                          ])
                        ], 8, _hoisted_11))
                      }), 128))
                    ], 4)
                  ]))
                : _createCommentVNode("", true),
              (this.dataList.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    (_ctx.disabledOk())
                      ? (_openBlock(), _createBlock(_component_Popover, {
                          key: 0,
                          placement: "top"
                        }, {
                          content: _withCtx(() => [
                            (
                    !_ctx.$store.state.authc.authc
                      .ButtonBasic_pg_basiData_terminalMap_sign
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 您当前没有权限进行标记操作,请联系管理员 "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Button, {
                              type: "primary",
                              onClick: _ctx.handleOk,
                              style: {"margin-right":"40px","padding":"0 30px"},
                              disabled: _ctx.disabledOk()
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 完成标记 ")
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          type: "primary",
                          onClick: _ctx.handleOk,
                          style: {"margin-right":"40px","padding":"0 30px"},
                          disabled: _ctx.disabledOk()
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 完成标记 ")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Tab_pane, {
            key: "2",
            tab: "标记日志",
            "force-render": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AuditLog, {
                activeKey: _ctx.activeKey,
                onClickItem: _ctx.clickItem,
                onIsEditItem: _ctx.isEditItem
              }, null, 8, ["activeKey", "onClickItem", "onIsEditItem"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeKey"])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_Map, {
        dataList: _ctx.dataList,
        isEdit: _ctx.isEdit,
        onDragendMarker: _ctx.dragendMarker,
        onRightClick: _ctx.rightClick,
        allowRightClick: _ctx.activeKey === '1'
      }, null, 8, ["dataList", "isEdit", "onDragendMarker", "onRightClick", "allowRightClick"]),
      _hoisted_42
    ]),
    _createVNode(_component_Modal, {
      class: "terminalMap",
      visible: _ctx.visibleModal,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visibleModal) = $event)),
      centered: "",
      onOk: _ctx.handleModalOk,
      confirmLoading: _ctx.confirmLoading,
      width: "1100px"
    }, {
      title: _withCtx(() => [
        _createVNode(_component_DecorateModalTitle, { modalTitle: "确认标记提示" })
      ]),
      default: _withCtx(() => [
        _hoisted_43,
        _createVNode(_component_Table, {
          rowKey: "fmesCode",
          columns: _ctx.columns,
          "data-source": 
          _ctx.dataList.filter((el) => {
            return el.signType == 1 || el.signType == 2;
          })
        ,
          pagination: false,
          size: "small"
        }, {
          terminalName: _withCtx(({ record }) => [
            _createElementVNode("div", {
              class: "terminalNameContainer",
              onClick: ($event: any) => (_ctx.terminalDetails(record.fmesCode))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", {
                    title: record.fmesName
                  }, _toDisplayString(record.fmesName), 9, _hoisted_46)
                ]),
                _createElementVNode("div", {
                  class: "terminalNameBox longBox",
                  style: {"color":"#ccc"},
                  title: record.fmesCode
                }, _toDisplayString(record.fmesCode), 9, _hoisted_47)
              ])
            ], 8, _hoisted_44)
          ]),
          province: _withCtx(({ record }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(record.province) + "/" + _toDisplayString(record.city) + "/" + _toDisplayString(record.area), 1),
                (record.town)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "/" + _toDisplayString(record.town), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "terminalNameBox",
                title: record.address
              }, [
                _createElementVNode("span", null, _toDisplayString(record.address), 1)
              ], 8, _hoisted_49)
            ])
          ]),
          baiduLat: _withCtx(({ record }) => [
            _createElementVNode("div", null, _toDisplayString(record.baiduLat), 1),
            _createElementVNode("div", null, _toDisplayString(record.baiduLon), 1)
          ]),
          signType: _withCtx(({ record }) => [
            _createElementVNode("div", null, _toDisplayString(record.signType == 1 ? "保留终端" : "重复终端"), 1)
          ]),
          _: 1
        }, 8, ["columns", "data-source"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "confirmLoading"])
  ], 4))
}